<div class="advice mb-4">
    <div class="d-flex container pe-lg-0 flex-column flex-md-row justify-content-between py-4 py-lg-0">
        <div class="d-flex flex-column justify-content-center">
            <div class="d-flex">
                <div class="d-flex flex-column align-items-between w-100 justify-content-center">
                    <h3 class="lh-base px-3">
                        <span class="cl-black fw-sbold">{{ splitTitle?.first }}</span><br class="d-none d-lg-block">
                        <span class="cl-primary fw-sbold"> {{ splitTitle?.second }}</span>
                        <span class="d-block d-md-none cl-blue fw-sbold mt-1 fs-20">{{ (user?.wallet?.balance) || '$0.00' }}</span>
                    </h3>
                </div>
                <div class="d-block d-md-none pe-3 mt-1"><a [routerLink]="routerLink === 'register' ? path.ROUTE_WALLET_HOME : path.USER_ONBOARDING"><img class="rotate" src="https://static.monific.com/assets/assets-app/img/wallet/arrow-icon.svg" alt="arrow-icon"></a></div>
            </div>
            <p class="cl-black px-3 lh-base" [innerHTML]="description"></p>
            <div class="d-flex align-items-center justify-content-center justify-content-md-start w-100 ps-md-3">
                <a  class="a-hover-white" [routerLink]="routerLink === 'register' ? path.ROUTE_USER_ONBOARDING : path.ROUTE_AVAILABLE_PROJECTS_HOME" class="btn mt-2 bg-primary cl-white rounded-4 px-4" [innerHTML]="button"></a>
            </div>
        </div>
        <div class="d-md-flex d-none align-items-center justify-content-end">
            <img [src]="image" alt="banner-reference">
        </div>
    </div>
</div>

